/* eslint-disable max-len */
/* eslint-disable no-console */
import { API } from 'aws-amplify';
import {
	UPDATE_CONTENT_TYPES,
	UpdateContentTypesPayload,
	ContentTypesStatus
} from './types';

// API endpoint name as configured in index.tsx
const API_NAME = 'revisedResources';

/**
 * Update the enabled/disabled status of content types
 * @param companyId - Company identifier
 * @param payload - Object containing the updated status for each content type
 * @returns The updated content types configuration
 */
export const updateContentTypes = async (
	companyId: string,
	payload: UpdateContentTypesPayload
): Promise<{ modulesEnabled: ContentTypesStatus }> =>
{
	try
	{
		const response = await API.patch(
			API_NAME,
			`/configurations/${companyId}/content-types`,
			{
				body : payload
			}
		);

		// Return the updated configuration
		if (response?.data?.modulesEnabled)
		{
			return {
				modulesEnabled : response.data.modulesEnabled
			};
		}

		// If no modulesEnabled in response, return what we sent
		// This handles edge cases where the API doesn't return the updated data
		return {
			modulesEnabled : payload
		};
	}
	catch (error)
	{
		console.error('Error updating content types:', error);
		throw error;
	}
};